var _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg01 = function Svg01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 172,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "01_svg__b",
    width: 64,
    height: 174,
    x: -1,
    y: -1,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1-1h64v174H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.902 172V34.36L37.846.88h23.312V172zM.15 51.224v-21.08q11.903-1.24 19.344-4.216Q26.934 22.952 31.15 17q4.464-5.952 6.696-16.12l6.2 50.344z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    d: "M30.902 172V34.36L37.846.88h23.312V172zM.15 51.224v-21.08q11.903-1.24 19.344-4.216Q26.934 22.952 31.15 17q4.464-5.952 6.696-16.12l6.2 50.344z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#01_svg__a)",
    d: "M30.902 172h-1v1h1zm0-137.64-.98-.203-.02.1v.103zM37.846.88v-1h-.814l-.166.797zm23.312 0h1v-1h-1zm0 171.12v1h1v-1zM.15 51.224h-1v1h1zm0-21.08-.104-.995-.897.094v.901zm19.344-4.216L19.122 25zM31.15 17l-.8-.6-.009.01-.008.012zM37.846.88l.992-.122-1.97-.092zm6.2 50.344v1h1.13l-.138-1.122zM31.902 172V34.36h-2V172zM31.88 34.563l6.944-33.48-1.959-.406-6.944 33.48zM37.846 1.88h23.312v-2H37.846zm22.312-1V172h2V.88zm1 170.12H30.9v2h30.257zM1.15 51.224v-21.08h-2v21.08zM.253 31.139c7.987-.832 14.535-2.252 19.612-4.282L19.122 25C14.28 26.937 7.931 28.328.046 29.15zm19.612-4.282c5.12-2.049 9.168-5.138 12.1-9.279l-1.631-1.156C27.645 20.217 23.922 23.08 19.122 25zM31.95 17.6c3.088-4.119 5.365-9.64 6.872-16.506L36.87.666c-1.469 6.69-3.656 11.917-6.52 15.734zm4.903-16.598 6.2 50.344 1.985-.244-6.2-50.344zm7.192 49.222H.15v2h43.896z",
    mask: "url(#01_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "01_svg__a",
    x1: 40,
    x2: 45,
    y1: -23.304,
    y2: 178.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96ea63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090B"
  })))));
};
export default Svg01;